var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"content-row",class:{ 'content-row--no-padding': _vm.noPadding }},[_c('div',{staticClass:"content-row__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }